export default __webpack_public_path__ + "static/media/Settings_Icon.6f3e6900.svg";